import { Collapse, Row } from 'antd'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import useTitle from 'app/lib/hooks/useTitle'
import { PageProps } from 'app/pages/typing'
import * as React from 'react'
import { useIntl } from 'react-intl'

import { faqData } from '../data'

const FAQIndex: React.FC<PageProps> = (props) => {
  const { title } = useTitle(props)
  const { formatMessage } = useIntl()
  return (
    <Row>
      <KCol span={24} card title={title}>
        {faqData.map((item: { header: string; length: number }, index: number) => {
          return (
            <div className="faq-category" key={'faq-' + index} id={item.header}>
              {Array.from({ length: item.length }, (_, i) => {
                const key = `faq-question-${i}`
                return (
                  <Collapse key={key}>
                    <Collapse.Panel
                      key={key}
                      header={
                        <h4 className="mb-0">
                          {formatMessage({ id: `faq.question.${item.header}.${i + 1}` })}
                        </h4>
                      }>
                      <p>{formatMessage({ id: `faq.answer.${item.header}.${i + 1}` })}</p>
                    </Collapse.Panel>
                  </Collapse>
                )
              })}
            </div>
          )
        })}
      </KCol>
    </Row>
  )
}

export default FAQIndex
